module.exports = __webpack_public_path__ + "static/media/main.4156ab65.png";